'use strict';

import auth from './auth';

import Welcome                from './components/welcome.vue';
import Landing                from './components/welcome/landing.vue';
import Register               from './components/welcome/register.vue';
import Login                  from './components/welcome/login.vue';
import Contact                from './components/contact.vue';
import ResendUserConfirmation from './components/resend-user-confirmation.vue';
import PasswordReset          from './components/password-reset.vue';
import ConfirmUser            from './components/confirm-user.vue';
import JoinPool               from './components/join-pool.vue';
import Dashboard              from './components/dashboard.vue';
import Account                from './components/account.vue';
import PoolArchives           from './components/pool-archives.vue';
import Faq                    from './components/faq.vue';
import PoolForm               from './components/pool-form.vue';
import Pool                   from './components/pool.vue';
import Admin                  from './components/admin.vue';
import AdminUsers             from './components/admin/users.vue';
import AppRedirect            from './components/app-redirect.vue';

export default [
  {
    path: '/landing',
    name: 'landing',
    component: Landing
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: Welcome,
    redirect: {name: 'register'},
    children: [
      {path: 'register',                              name: 'register',               component: Register},
      {path: 'login',                                 name: 'login',                  component: Login}
    ]
  },
  {path: '/resend-user-confirmation',                 name: 'resendUserConfirmation', component: ResendUserConfirmation},
  {path: '/password-reset/:email?',                   name: 'passwordReset',          component: PasswordReset},
  {path: '/confirm-user/:email?/:emailVerification?', name: 'confirmUser',            component: ConfirmUser},
  {path: '/join-pool/:participationVerification',     name: 'joinPool',               component: JoinPool},
  {path: '/dashboard',                                name: 'dashboard',              component: Dashboard,      beforeEnter: auth.authRoute},
  {path: '/contact',                                  name: 'contact',                component: Contact,        beforeEnter: auth.authRoute},
  {path: '/account',                                  name: 'account',                component: Account,        beforeEnter: auth.authRoute},
  {path: '/pool-archives',                            name: 'poolArchives',           component: PoolArchives,   beforeEnter: auth.authRoute},
  {path: '/faq',                                      name: 'faq',                    component: Faq,            beforeEnter: auth.authRoute},
  {path: '/new-pool',                                 name: 'newPool',                component: PoolForm,       beforeEnter: auth.authRoute},
  {path: '/edit-pool/:id',                            name: 'editPool',               component: PoolForm,       beforeEnter: auth.authRoute},
  {path: '/pool/:id',                                 name: 'pool',                   component: Pool,           beforeEnter: auth.authRoute},
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    beforeEnter: auth.authRoute,
    children: [
      {path: 'users',                                 name: 'adminUsers',             component: AdminUsers}
    ]
  },

  {path: '/',                                         name: 'appRedirect',          component: AppRedirect},
  {path: '*',               redirect: {name: 'dashboard'}}
];
